import type { AssetFromClipboardData } from 'owa-timestream-asset-sdk-types';
import { DEFAULT_MIN_ASSET_WIDTH } from 'owa-timestream-asset-sdk';
import type { FileLinkPayload } from '../schema';

export default function createOneNoteLinkFromClipboardData(
    getData: (format: 'text/plain' | 'text/html') => string
): AssetFromClipboardData<FileLinkPayload> {
    // OneNote links can come with one or two URLs in text/plain.
    // It can be an https link or a onenote:https link.
    // It depends on the version of OneNote and where the document is stored.
    // We will use just the first URL, whatever it is.
    const url = getData('text/plain')
        .split(/\r?\n/)
        .filter(x => x)
        .sort()[0];
    if (!url) {
        return null;
    }

    // tslint:disable-next-line:no-http-string
    const prefixes = ['https://', 'onenote:https://'];
    if (!prefixes.some(p => url.indexOf(p) == 0)) {
        return null;
    }

    // The title can be found in the HTML data.
    const textHtml = getData('text/html');
    const titleRegExp = /<a[\s\n]+href="onenote:[^"]+">([^/]*)<\/a>/gm;
    const titleMatch = titleRegExp.exec(textHtml);
    if (!titleMatch) {
        return null;
    }

    const title = titleMatch[1];
    return {
        type: 'file',
        width: DEFAULT_MIN_ASSET_WIDTH,
        payload: {
            filePickerLinkData: {
                fileName: title,
                mimeType: 'application/onenote',
                isFolder: false,
            },
            fileProvider: null,
            fileId: '',
            location: '',
            url,
            thumbnailUrl: '',
            providerEndpointUrl: '',
        },
    };
}
